module.exports = __webpack_public_path__ + "img/p08.1b789179.jpg";